import { Button, Col, Divider, Form, Input, Modal, Row, Select, Space } from "antd";
import { PlatIngredient } from "../../../model/menudesign/PlatIngredient";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PlusOutlined } from "@ant-design/icons";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { useEffect, useState } from "react";
import { GetIngredients } from "../../../dao/menudesign/GetIngredients";
import Ingredient from "../../../model/menudesign/Ingredient";
import { PostIngredientsPlat } from "../../../dao/menudesign/PostIngredientsPlat";

interface IngredientModalProps {
    element: PlatIngredient;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
}
const PlatIngredientModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    const [plats, setPlats] = useState<{ value: number; label: string; }[]>([]);
    const [ingredients, setIngredients] = useState<{ value: number; label: string; }[]>([]);
    
    async function checkListas(){
        const dades = await GetPlats(page) || [];
        const ingredients = await GetIngredients(page);
        const platList = dades.map((element) => ({
            value: element.id,
            label: element.nom,
        }));
        const ingList = ingredients.map((element: Ingredient) => ({
            value: element.id,
            label: element.nom,
        }))
        setPlats(platList);
        setIngredients(ingList);
    }
    async function handleSubmit() {
        const id_plat = await form.getFieldValue('id_plat');
        const id_ingredient = await form.getFieldValue('id_ingredient');
        const qInfantil = await form.getFieldValue('qInfantil');
        const qPrimaria = await form.getFieldValue('qPrimaria');
        const qAdult = await form.getFieldValue('qAdult');
        const per100 = await form.getFieldValue('per100');
        await PostIngredientsPlat(id_plat,id_ingredient,qInfantil,qPrimaria,qAdult,per100,page);
        await onClose();
    };
    async function handleCancel() {
        await onClose();
    };
    useEffect(() => {
        checkListas();
    }, []);
    if(!editar){
        return (
            <Modal
            title="Mostrar Ingredient de Plat"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={500}
            >
                <Form form={form} initialValues={element}>
                    <br/>
                    <Row gutter={[16, 16]}>
                        <Col span={42}>
                            <Form.Item label="ID Plat" name="id_plat">
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={plats}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item label="ID Ingredient" name="id_ingredient">
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={ingredients}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item label="Quant Infantil" name="qInfantil"
                                rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type="number" min={0} disabled/>
                            </Form.Item>
                            <Form.Item label="Quant Primaria" name="qPrimaria">
                                <Input type="number" min={0} disabled/>
                            </Form.Item>
                            <Form.Item label="Quant Adult" name="qAdult">
                                <Input type="number" min={0} disabled/>
                            </Form.Item>
                            <Form.Item label="Percentatge" name="per100">
                                <Input type="number" min={0} max={100} disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
    return (
        <Modal
        title="Crear/Editar Ingredient de Plat"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={500}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID Plat" name="id_plat"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={plats}
                            />
                        </Form.Item>
                        <Form.Item label="ID Ingredient" name="id_ingredient"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={ingredients}
                            />
                        </Form.Item>
                        <Form.Item label="Quant Infantil" name="qInfantil"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" min={0}/>
                        </Form.Item>
                        <Form.Item label="Quant Primaria" name="qPrimaria"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" min={0}/>
                        </Form.Item>
                        <Form.Item label="Quant Adult" name="qAdult"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" min={0}/>
                        </Form.Item>
                        <Form.Item label="Percentatge" name="per100"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" min={0} max={100}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
export default PlatIngredientModal;